module.exports = __webpack_public_path__ + "static/media/10.e6bb3753.jpg";